import PropTypes from 'prop-types';
import React from 'react';
import MemberListItem from '../member-list-item/member-list-item-desktop';
import styles from './member-list-desktop.scss';

const MemberListDesktop = ({ members }) =>
  <div>
    <div className={styles.wrapper}>
      {members.map(member =>
        <div className={styles.item} key={member._id}>
          <MemberListItem member={member}/>
        </div>
      )}
    </div>
  </div>;

MemberListDesktop.propTypes = {
  members: PropTypes.array.isRequired,
};

export default MemberListDesktop;



// WEBPACK FOOTER //
// ./app/components/member-list/member-list-desktop.js